import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface VehicleDto {
  id: string;
  registrationNumber: string;
  nameOrDescription: string;
  vehicleType?: string;
  capacity: number;
  capacityUnit: string;
  status: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateVehicleRequest {
  registrationNumber: string;
  nameOrDescription: string;
  vehicleType?: string;
  capacity?: number;
  capacityUnit?: string;
  status: string;
  notes?: string;
}

export interface UpdateVehicleRequest {
  registrationNumber: string;
  nameOrDescription: string;
  vehicleType?: string;
  capacity?: number;
  capacityUnit?: string;
  status: string;
  notes?: string;
  isActive: boolean;
}

export interface VehicleListResultDto {
  items: VehicleDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface VehicleListQuery {
  search?: string;
  vehicleType?: string;
  status?: string;
  isActive?: boolean;
  pageNumber?: number;
  pageSize?: number;
}

export const vehiclesApi = {
  getPaged: async (query: VehicleListQuery = {}): Promise<VehicleListResultDto> => {
    const params = new URLSearchParams();
    if (query.search) params.set("search", query.search);
    if (query.vehicleType) params.set("vehicleType", query.vehicleType);
    if (query.status) params.set("status", query.status);
    if (query.isActive !== undefined) params.set("isActive", String(query.isActive));
    if (query.pageNumber) params.set("pageNumber", String(query.pageNumber));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    const res = await apiClient.get<ApiResponse<VehicleListResultDto>>(
      `/vehicles/paged?${params.toString()}`
    );
    return res.data.data!;
  },

  getAll: async (activeOnly: boolean | undefined = true): Promise<VehicleDto[]> => {
    const params = new URLSearchParams();
    params.set("pageSize", "200");
    if (activeOnly !== undefined) {
      params.set("isActive", String(activeOnly));
    }

    const res = await apiClient.get<ApiResponse<VehicleListResultDto>>(
      `/vehicles/paged?${params.toString()}`
    );
    return res.data.data!.items;
  },

  create: async (data: CreateVehicleRequest): Promise<VehicleDto> => {
    const res = await apiClient.post<ApiResponse<VehicleDto>>("/vehicles", data);
    return res.data.data;
  },

  update: async (id: string, data: UpdateVehicleRequest): Promise<VehicleDto> => {
    const res = await apiClient.put<ApiResponse<VehicleDto>>(`/vehicles/${id}`, data);
    return res.data.data;
  },
};
